import Autocomplete from '@mui/material/Autocomplete'
import Box from '@mui/material/Box'
import Button from '@mui/material/Button'
import Chip from '@mui/material/Chip'
import Grid from '@mui/material/Grid'
import TextField from '@mui/material/TextField'
import { useIsFetching } from '@tanstack/react-query'
import { useDriversView } from 'context/DriversViewContext'
import { analyticsEvent } from 'global/helpers/analytics'
import { type ReactElement, useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { DRIVERS_QUERY_KEY } from './DriverManager.service'

const DriverFilters = (): ReactElement => {
  const { t } = useTranslation()
  const { filters, filtersDirty, setFilters, resetFilters } = useDriversView()
  const isFetching = useIsFetching({ queryKey: [DRIVERS_QUERY_KEY] })

  const handleResetClick = useCallback((): void => {
    resetFilters()
    analyticsEvent('polestar_cs_driver_filters_reset')
  }, [])

  return (
    <Box sx={{ position: 'relative' }}>
      <Grid container spacing={2}>
        <Grid size={{ xs: 12, sm: 4 }}>
          <Autocomplete
            multiple
            freeSolo
            options={[]}
            value={filters.keywords}
            onChange={(event, newValue): void => {
              setFilters({
                keywords: newValue,
              })
              analyticsEvent('polestar_cs_driver_filters', ['keywords', newValue.join(', ')])
            }}
            renderValue={(tagValue, getTagProps): ReactElement[] =>
              tagValue.map((option, index) => (
                // eslint-disable-next-line react/jsx-key
                <Chip {...getTagProps({ index })} variant="outlined" size="small" label={option} />
              ))
            }
            renderInput={(params): ReactElement => (
              <TextField {...params} label={t('screens.cs.driver_manager.filters.search')} />
            )}
            disabled={isFetching > 0}
          />
        </Grid>
      </Grid>
      {filtersDirty && (
        <Button
          size="small"
          variant="text"
          color="primary"
          onClick={handleResetClick}
          sx={{
            padding: 0,
            minHeight: 'auto',
          }}
        >
          {t('general.reset_filters')}
        </Button>
      )}
    </Box>
  )
}

export default DriverFilters
